module.exports = __webpack_public_path__ + "static/media/caution.c61bcdb6.svg";